import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ButtonBase from '@mui/material/ButtonBase';

import Logo from './LogoMain';
import LogoIcon from './LogoIcon';
import { APP_DEFAULT_PATH } from 'config';

export default function LogoSection({ isIcon, showTagline, sx, to }) {
  return (
    <ButtonBase disableRipple component={Link} to={to || APP_DEFAULT_PATH} sx={sx} aria-label="ЯШЕН — управление турами">
      {isIcon ? <LogoIcon /> : <Logo showTagline={showTagline} />}
    </ButtonBase>
  );
}

LogoSection.propTypes = {
  isIcon: PropTypes.bool,
  showTagline: PropTypes.bool,
  sx: PropTypes.any,
  to: PropTypes.any
};
